import { render, staticRenderFns } from "./editManageBlockResource.vue?vue&type=template&id=21e1241a&scoped=true"
import script from "./editManageBlockResource.vue?vue&type=script&lang=js"
export * from "./editManageBlockResource.vue?vue&type=script&lang=js"
import style0 from "./editManageBlockResource.vue?vue&type=style&index=0&id=21e1241a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1241a",
  null
  
)

export default component.exports